
/**
 * @roxi/routify 2.18.11
 * File generated Tue Dec 16 2025 12:03:57 GMT+0000 (Coordinated Universal Time)
 */

export const __version = "2.18.11"
export const __timestamp = "2025-12-16T12:03:57.136Z"

//buildRoutes
import { buildClientTree } from "@roxi/routify/runtime/buildRoutes"

//imports


//options
export const options = {}

//tree
export const _tree = {
  "root": true,
  "children": [
    {
      "isFallback": true,
      "path": "/_fallback",
      "component": () => import('../src/pages/_fallback.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "children": [
        {
          "isPage": true,
          "meta": {
            "recursive": true,
            "preload": "proximity",
            "prerender": true
          },
          "path": "/account_application_verification/error",
          "id": "_account_application_verification_error",
          "component": () => import('../src/pages/account_application_verification/error.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "meta": {
            "recursive": true,
            "preload": "proximity",
            "prerender": true
          },
          "path": "/account_application_verification/expired",
          "id": "_account_application_verification_expired",
          "component": () => import('../src/pages/account_application_verification/expired.svelte').then(m => m.default)
        },
        {
          "isIndex": true,
          "isPage": true,
          "meta": {
            "recursive": true,
            "preload": "proximity",
            "prerender": true
          },
          "path": "/account_application_verification/index",
          "id": "_account_application_verification_index",
          "component": () => import('../src/pages/account_application_verification/index.svelte').then(m => m.default)
        }
      ],
      "isLayout": true,
      "isReset": true,
      "ownMeta": {
        "preload": "proximity"
      },
      "meta": {
        "preload": "proximity",
        "recursive": true,
        "prerender": true
      },
      "path": "/account_application_verification",
      "id": "_account_application_verification__reset",
      "component": () => import('../src/pages/account_application_verification/_reset.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "path": "/apply/:id",
          "id": "_apply__id",
          "component": () => import('../src/pages/apply/[id].svelte').then(m => m.default)
        }
      ],
      "path": "/apply"
    },
    {
      "isPage": true,
      "path": "/apply",
      "id": "_apply",
      "component": () => import('../src/pages/apply.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "path": "/cart/success",
          "id": "_cart_success",
          "component": () => import('../src/pages/cart/success.svelte').then(m => m.default)
        }
      ],
      "path": "/cart"
    },
    {
      "isPage": true,
      "path": "/cart",
      "id": "_cart",
      "component": () => import('../src/pages/cart.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isIndex": true,
          "isPage": true,
          "path": "/credential_management/index",
          "id": "_credential_management_index",
          "component": () => import('../src/pages/credential_management/index.svelte').then(m => m.default)
        }
      ],
      "path": "/credential_management"
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "ownMeta": {
            "param-is-page": true
          },
          "meta": {
            "param-is-page": true,
            "recursive": true,
            "preload": false,
            "prerender": true
          },
          "path": "/deals/:dealId",
          "id": "_deals__dealId",
          "component": () => import('../src/pages/deals/[dealId].svelte').then(m => m.default)
        },
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isDir": true,
              "ext": "",
              "children": [
                {
                  "isPage": true,
                  "ownMeta": {
                    "param-is-page": true
                  },
                  "meta": {
                    "param-is-page": true,
                    "recursive": true,
                    "preload": false,
                    "prerender": true
                  },
                  "path": "/deals/v2/:distributorId/:productGroupId",
                  "id": "_deals_v2__distributorId__productGroupId",
                  "component": () => import('../src/pages/deals/v2/[distributorId]/[productGroupId].svelte').then(m => m.default)
                }
              ],
              "path": "/deals/v2/:distributorId"
            }
          ],
          "path": "/deals/v2"
        }
      ],
      "path": "/deals"
    },
    {
      "isDir": true,
      "children": [
        {
          "isFallback": true,
          "path": "/demo/_fallback",
          "id": "_demo__fallback",
          "component": () => import('../src/pages/demo/_fallback.svelte').then(m => m.default)
        },
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isPage": true,
              "path": "/demo/storefront/:distributorId",
              "id": "_demo_storefront__distributorId",
              "component": () => import('../src/pages/demo/storefront/[distributorId].svelte').then(m => m.default)
            }
          ],
          "path": "/demo/storefront"
        }
      ],
      "isLayout": true,
      "isReset": true,
      "path": "/demo",
      "id": "_demo__reset",
      "component": () => import('../src/pages/demo/_reset.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "children": [
        {
          "isFallback": true,
          "meta": {
            "recursive": true,
            "preload": "proximity",
            "prerender": true
          },
          "path": "/distributor/_fallback",
          "id": "_distributor__fallback",
          "component": () => import('../src/pages/distributor/_fallback.svelte').then(m => m.default)
        },
        {
          "isIndex": true,
          "isPage": true,
          "meta": {
            "recursive": true,
            "preload": "proximity",
            "prerender": true
          },
          "path": "/distributor/index",
          "id": "_distributor_index",
          "component": () => import('../src/pages/distributor/index.svelte').then(m => m.default)
        },
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isIndex": true,
              "isPage": true,
              "meta": {
                "recursive": true,
                "preload": "proximity",
                "prerender": true
              },
              "path": "/distributor/notifications/index",
              "id": "_distributor_notifications_index",
              "component": () => import('../src/pages/distributor/notifications/index.svelte').then(m => m.default)
            }
          ],
          "meta": {
            "recursive": true,
            "preload": "proximity",
            "prerender": true
          },
          "path": "/distributor/notifications"
        },
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isIndex": true,
              "isPage": true,
              "meta": {
                "recursive": true,
                "preload": "proximity",
                "prerender": true
              },
              "path": "/distributor/payments/index",
              "id": "_distributor_payments_index",
              "component": () => import('../src/pages/distributor/payments/index.svelte').then(m => m.default)
            }
          ],
          "meta": {
            "recursive": true,
            "preload": "proximity",
            "prerender": true
          },
          "path": "/distributor/payments"
        },
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isPage": true,
              "meta": {
                "recursive": true,
                "preload": "proximity",
                "prerender": true
              },
              "path": "/distributor/product_sheets/:productSheetId",
              "id": "_distributor_product_sheets__productSheetId",
              "component": () => import('../src/pages/distributor/product_sheets/[productSheetId].svelte').then(m => m.default)
            },
            {
              "isIndex": true,
              "isPage": true,
              "meta": {
                "recursive": true,
                "preload": "proximity",
                "prerender": true
              },
              "path": "/distributor/product_sheets/index",
              "id": "_distributor_product_sheets_index",
              "component": () => import('../src/pages/distributor/product_sheets/index.svelte').then(m => m.default)
            },
            {
              "isDir": true,
              "ext": "",
              "children": [
                {
                  "isPage": true,
                  "meta": {
                    "recursive": true,
                    "preload": "proximity",
                    "prerender": true
                  },
                  "path": "/distributor/product_sheets/preview/:productSheetId",
                  "id": "_distributor_product_sheets_preview__productSheetId",
                  "component": () => import('../src/pages/distributor/product_sheets/preview/[productSheetId].svelte').then(m => m.default)
                }
              ],
              "meta": {
                "recursive": true,
                "preload": "proximity",
                "prerender": true
              },
              "path": "/distributor/product_sheets/preview"
            }
          ],
          "meta": {
            "recursive": true,
            "preload": "proximity",
            "prerender": true
          },
          "path": "/distributor/product_sheets"
        },
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isIndex": true,
              "isPage": true,
              "meta": {
                "recursive": true,
                "preload": "proximity",
                "prerender": true
              },
              "path": "/distributor/profile/index",
              "id": "_distributor_profile_index",
              "component": () => import('../src/pages/distributor/profile/index.svelte').then(m => m.default)
            }
          ],
          "meta": {
            "recursive": true,
            "preload": "proximity",
            "prerender": true
          },
          "path": "/distributor/profile"
        },
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isIndex": true,
              "isPage": true,
              "meta": {
                "recursive": true,
                "preload": "proximity",
                "prerender": true
              },
              "path": "/distributor/retailer_onboarding/index",
              "id": "_distributor_retailer_onboarding_index",
              "component": () => import('../src/pages/distributor/retailer_onboarding/index.svelte').then(m => m.default)
            }
          ],
          "meta": {
            "recursive": true,
            "preload": "proximity",
            "prerender": true
          },
          "path": "/distributor/retailer_onboarding"
        },
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isPage": true,
              "meta": {
                "recursive": true,
                "preload": "proximity",
                "prerender": true
              },
              "path": "/distributor/retailers/:retailerId",
              "id": "_distributor_retailers__retailerId",
              "component": () => import('../src/pages/distributor/retailers/[retailerId].svelte').then(m => m.default)
            },
            {
              "isIndex": true,
              "isPage": true,
              "meta": {
                "recursive": true,
                "preload": "proximity",
                "prerender": true
              },
              "path": "/distributor/retailers/index",
              "id": "_distributor_retailers_index",
              "component": () => import('../src/pages/distributor/retailers/index.svelte').then(m => m.default)
            }
          ],
          "meta": {
            "recursive": true,
            "preload": "proximity",
            "prerender": true
          },
          "path": "/distributor/retailers"
        },
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isPage": true,
              "meta": {
                "recursive": true,
                "preload": "proximity",
                "prerender": true
              },
              "path": "/distributor/sales_reps/:salesRepId",
              "id": "_distributor_sales_reps__salesRepId",
              "component": () => import('../src/pages/distributor/sales_reps/[salesRepId].svelte').then(m => m.default)
            },
            {
              "isIndex": true,
              "isPage": true,
              "meta": {
                "recursive": true,
                "preload": "proximity",
                "prerender": true
              },
              "path": "/distributor/sales_reps/index",
              "id": "_distributor_sales_reps_index",
              "component": () => import('../src/pages/distributor/sales_reps/index.svelte').then(m => m.default)
            }
          ],
          "meta": {
            "recursive": true,
            "preload": "proximity",
            "prerender": true
          },
          "path": "/distributor/sales_reps"
        },
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isPage": true,
              "meta": {
                "recursive": true,
                "preload": "proximity",
                "prerender": true
              },
              "path": "/distributor/storefronts/:distributorId",
              "id": "_distributor_storefronts__distributorId",
              "component": () => import('../src/pages/distributor/storefronts/[distributorId].svelte').then(m => m.default)
            },
            {
              "isIndex": true,
              "isPage": true,
              "meta": {
                "recursive": true,
                "preload": "proximity",
                "prerender": true
              },
              "path": "/distributor/storefronts/index",
              "id": "_distributor_storefronts_index",
              "component": () => import('../src/pages/distributor/storefronts/index.svelte').then(m => m.default)
            },
            {
              "isDir": true,
              "ext": "",
              "children": [
                {
                  "isPage": true,
                  "meta": {
                    "recursive": true,
                    "preload": "proximity",
                    "prerender": true
                  },
                  "path": "/distributor/storefronts/preview/:distributorId",
                  "id": "_distributor_storefronts_preview__distributorId",
                  "component": () => import('../src/pages/distributor/storefronts/preview/[distributorId].svelte').then(m => m.default)
                }
              ],
              "meta": {
                "recursive": true,
                "preload": "proximity",
                "prerender": true
              },
              "path": "/distributor/storefronts/preview"
            },
            {
              "isDir": true,
              "ext": "",
              "children": [
                {
                  "isPage": true,
                  "meta": {
                    "recursive": true,
                    "preload": "proximity",
                    "prerender": true
                  },
                  "path": "/distributor/storefronts/preview_content/:distributorId",
                  "id": "_distributor_storefronts_preview_content__distributorId",
                  "component": () => import('../src/pages/distributor/storefronts/preview_content/[distributorId].svelte').then(m => m.default)
                }
              ],
              "meta": {
                "recursive": true,
                "preload": "proximity",
                "prerender": true
              },
              "path": "/distributor/storefronts/preview_content"
            }
          ],
          "meta": {
            "recursive": true,
            "preload": "proximity",
            "prerender": true
          },
          "path": "/distributor/storefronts"
        },
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isIndex": true,
              "isPage": true,
              "meta": {
                "recursive": true,
                "preload": "proximity",
                "prerender": true
              },
              "path": "/distributor/vacations/index",
              "id": "_distributor_vacations_index",
              "component": () => import('../src/pages/distributor/vacations/index.svelte').then(m => m.default)
            }
          ],
          "meta": {
            "recursive": true,
            "preload": "proximity",
            "prerender": true
          },
          "path": "/distributor/vacations"
        }
      ],
      "isLayout": true,
      "isReset": true,
      "ownMeta": {
        "preload": "proximity"
      },
      "meta": {
        "preload": "proximity",
        "recursive": true,
        "prerender": true
      },
      "path": "/distributor",
      "id": "_distributor__reset",
      "component": () => import('../src/pages/distributor/_reset.svelte').then(m => m.default)
    },
    {
      "isPage": true,
      "path": "/distributors",
      "id": "_distributors",
      "component": () => import('../src/pages/distributors.svelte').then(m => m.default)
    },
    {
      "isIndex": true,
      "isPage": true,
      "path": "/index",
      "id": "_index",
      "component": () => import('../src/pages/index.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "path": "/invoices/:invoiceId",
          "id": "_invoices__invoiceId",
          "component": () => import('../src/pages/invoices/[invoiceId].svelte').then(m => m.default)
        },
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isPage": true,
              "path": "/invoices/credits/:invoiceId",
              "id": "_invoices_credits__invoiceId",
              "component": () => import('../src/pages/invoices/credits/[invoiceId].svelte').then(m => m.default)
            }
          ],
          "path": "/invoices/credits"
        },
        {
          "isPage": true,
          "path": "/invoices/credits",
          "id": "_invoices_credits",
          "component": () => import('../src/pages/invoices/credits.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/invoices/settings",
          "id": "_invoices_settings",
          "component": () => import('../src/pages/invoices/settings.svelte').then(m => m.default)
        }
      ],
      "path": "/invoices"
    },
    {
      "isPage": true,
      "path": "/invoices",
      "id": "_invoices",
      "component": () => import('../src/pages/invoices.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "path": "/lists/:listId",
          "id": "_lists__listId",
          "component": () => import('../src/pages/lists/[listId].svelte').then(m => m.default)
        }
      ],
      "path": "/lists"
    },
    {
      "isPage": true,
      "path": "/lists",
      "id": "_lists",
      "component": () => import('../src/pages/lists.svelte').then(m => m.default)
    },
    {
      "isPage": true,
      "path": "/messaging",
      "id": "_messaging",
      "component": () => import('../src/pages/messaging.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "path": "/orders/:orderId",
          "id": "_orders__orderId",
          "component": () => import('../src/pages/orders/[orderId].svelte').then(m => m.default)
        }
      ],
      "path": "/orders"
    },
    {
      "isPage": true,
      "path": "/orders",
      "id": "_orders",
      "component": () => import('../src/pages/orders.svelte').then(m => m.default)
    },
    {
      "isPage": true,
      "path": "/product_approvals",
      "id": "_product_approvals",
      "component": () => import('../src/pages/product_approvals.svelte').then(m => m.default)
    },
    {
      "isPage": true,
      "path": "/product_listing",
      "id": "_product_listing",
      "component": () => import('../src/pages/product_listing.svelte').then(m => m.default)
    },
    {
      "isPage": true,
      "path": "/product_missing",
      "id": "_product_missing",
      "component": () => import('../src/pages/product_missing.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "ownMeta": {
            "param-is-page": true
          },
          "meta": {
            "param-is-page": true,
            "recursive": true,
            "preload": false,
            "prerender": true
          },
          "path": "/products/:productId",
          "id": "_products__productId",
          "component": () => import('../src/pages/products/[productId].svelte').then(m => m.default)
        }
      ],
      "path": "/products"
    },
    {
      "isPage": true,
      "ownMeta": {
        "query-param-is-page": true
      },
      "meta": {
        "query-param-is-page": true,
        "recursive": true,
        "preload": false,
        "prerender": true
      },
      "path": "/refer",
      "id": "_refer",
      "component": () => import('../src/pages/refer.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "path": "/rep_recommendations/:id",
          "id": "_rep_recommendations__id",
          "component": () => import('../src/pages/rep_recommendations/[id].svelte').then(m => m.default)
        },
        {
          "isIndex": true,
          "isPage": true,
          "path": "/rep_recommendations/index",
          "id": "_rep_recommendations_index",
          "component": () => import('../src/pages/rep_recommendations/index.svelte').then(m => m.default)
        }
      ],
      "path": "/rep_recommendations"
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isIndex": true,
          "isPage": true,
          "path": "/reports/index",
          "id": "_reports_index",
          "component": () => import('../src/pages/reports/index.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/reports/orders",
          "id": "_reports_orders",
          "component": () => import('../src/pages/reports/orders.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/reports/products",
          "id": "_reports_products",
          "component": () => import('../src/pages/reports/products.svelte').then(m => m.default)
        }
      ],
      "path": "/reports"
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "ownMeta": {
            "param-is-page": true
          },
          "meta": {
            "param-is-page": true,
            "recursive": true,
            "preload": false,
            "prerender": true
          },
          "path": "/sc/:slug",
          "id": "_sc__slug",
          "component": () => import('../src/pages/sc/[slug].svelte').then(m => m.default)
        }
      ],
      "path": "/sc"
    },
    {
      "isPage": true,
      "path": "/sculpture_reports",
      "id": "_sculpture_reports",
      "component": () => import('../src/pages/sculpture_reports.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "path": "/settings/accounts",
          "id": "_settings_accounts",
          "component": () => import('../src/pages/settings/accounts.svelte').then(m => m.default)
        },
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isPage": true,
              "path": "/settings/employees/:userId",
              "id": "_settings_employees__userId",
              "component": () => import('../src/pages/settings/employees/[userId].svelte').then(m => m.default)
            },
            {
              "isIndex": true,
              "isPage": true,
              "path": "/settings/employees/index",
              "id": "_settings_employees_index",
              "component": () => import('../src/pages/settings/employees/index.svelte').then(m => m.default)
            }
          ],
          "path": "/settings/employees"
        },
        {
          "isIndex": true,
          "isPage": true,
          "path": "/settings/index",
          "id": "_settings_index",
          "component": () => import('../src/pages/settings/index.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/settings/locations",
          "id": "_settings_locations",
          "component": () => import('../src/pages/settings/locations.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/settings/notifications",
          "id": "_settings_notifications",
          "component": () => import('../src/pages/settings/notifications.svelte').then(m => m.default)
        },
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isPage": true,
              "path": "/settings/pricing/:distributorId",
              "id": "_settings_pricing__distributorId",
              "component": () => import('../src/pages/settings/pricing/[distributorId].svelte').then(m => m.default)
            },
            {
              "isIndex": true,
              "isPage": true,
              "path": "/settings/pricing/index",
              "id": "_settings_pricing_index",
              "component": () => import('../src/pages/settings/pricing/index.svelte').then(m => m.default)
            }
          ],
          "path": "/settings/pricing"
        },
        {
          "isPage": true,
          "path": "/settings/profile",
          "id": "_settings_profile",
          "component": () => import('../src/pages/settings/profile.svelte').then(m => m.default)
        }
      ],
      "path": "/settings"
    },
    {
      "isDir": true,
      "children": [
        {
          "isIndex": true,
          "isPage": true,
          "meta": {
            "recursive": true,
            "preload": "proximity",
            "prerender": true
          },
          "path": "/specs_onboarding/index",
          "id": "_specs_onboarding_index",
          "component": () => import('../src/pages/specs_onboarding/index.svelte').then(m => m.default)
        }
      ],
      "isLayout": true,
      "isReset": true,
      "ownMeta": {
        "preload": "proximity"
      },
      "meta": {
        "preload": "proximity",
        "recursive": true,
        "prerender": true
      },
      "path": "/specs_onboarding",
      "id": "_specs_onboarding__reset",
      "component": () => import('../src/pages/specs_onboarding/_reset.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "ownMeta": {
            "param-is-page": true
          },
          "meta": {
            "param-is-page": true,
            "recursive": true,
            "preload": false,
            "prerender": true
          },
          "path": "/storefront/:distributor_id",
          "id": "_storefront__distributor_id",
          "component": () => import('../src/pages/storefront/[distributor_id].svelte').then(m => m.default)
        }
      ],
      "path": "/storefront"
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isPage": true,
              "ownMeta": {
                "param-is-page": true
              },
              "meta": {
                "param-is-page": true,
                "recursive": true,
                "preload": false,
                "prerender": true
              },
              "path": "/storefronts/find_storefront/:distributor_id",
              "id": "_storefronts_find_storefront__distributor_id",
              "component": () => import('../src/pages/storefronts/find_storefront/[distributor_id].svelte').then(m => m.default)
            }
          ],
          "path": "/storefronts/find_storefront"
        }
      ],
      "path": "/storefronts"
    },
    {
      "isDir": true,
      "children": [
        {
          "isFallback": true,
          "meta": {
            "recursive": true,
            "preload": "proximity",
            "prerender": true
          },
          "path": "/supplier/_fallback",
          "id": "_supplier__fallback",
          "component": () => import('../src/pages/supplier/_fallback.svelte').then(m => m.default)
        },
        {
          "isIndex": true,
          "isPage": true,
          "meta": {
            "recursive": true,
            "preload": "proximity",
            "prerender": true
          },
          "path": "/supplier/index",
          "id": "_supplier_index",
          "component": () => import('../src/pages/supplier/index.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "meta": {
            "recursive": true,
            "preload": "proximity",
            "prerender": true
          },
          "path": "/supplier/inventory",
          "id": "_supplier_inventory",
          "component": () => import('../src/pages/supplier/inventory.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "meta": {
            "recursive": true,
            "preload": "proximity",
            "prerender": true
          },
          "path": "/supplier/preview",
          "id": "_supplier_preview",
          "component": () => import('../src/pages/supplier/preview.svelte').then(m => m.default)
        },
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isPage": true,
              "meta": {
                "recursive": true,
                "preload": "proximity",
                "prerender": true
              },
              "path": "/supplier/product_sheets/:productSheetId",
              "id": "_supplier_product_sheets__productSheetId",
              "component": () => import('../src/pages/supplier/product_sheets/[productSheetId].svelte').then(m => m.default)
            },
            {
              "isIndex": true,
              "isPage": true,
              "meta": {
                "recursive": true,
                "preload": "proximity",
                "prerender": true
              },
              "path": "/supplier/product_sheets/index",
              "id": "_supplier_product_sheets_index",
              "component": () => import('../src/pages/supplier/product_sheets/index.svelte').then(m => m.default)
            },
            {
              "isDir": true,
              "ext": "",
              "children": [
                {
                  "isPage": true,
                  "meta": {
                    "recursive": true,
                    "preload": "proximity",
                    "prerender": true
                  },
                  "path": "/supplier/product_sheets/preview/:productSheetId",
                  "id": "_supplier_product_sheets_preview__productSheetId",
                  "component": () => import('../src/pages/supplier/product_sheets/preview/[productSheetId].svelte').then(m => m.default)
                }
              ],
              "meta": {
                "recursive": true,
                "preload": "proximity",
                "prerender": true
              },
              "path": "/supplier/product_sheets/preview"
            }
          ],
          "meta": {
            "recursive": true,
            "preload": "proximity",
            "prerender": true
          },
          "path": "/supplier/product_sheets"
        }
      ],
      "isLayout": true,
      "isReset": true,
      "ownMeta": {
        "preload": "proximity"
      },
      "meta": {
        "preload": "proximity",
        "recursive": true,
        "prerender": true
      },
      "path": "/supplier",
      "id": "_supplier__reset",
      "component": () => import('../src/pages/supplier/_reset.svelte').then(m => m.default)
    }
  ],
  "isLayout": true,
  "path": "/",
  "id": "__layout",
  "component": () => import('../src/pages/_layout.svelte').then(m => m.default)
}


export const {tree, routes} = buildClientTree(_tree)

